export const BrowserPhoneState = {
  DISCONNECTED: "DISCONNECTED",
  CONNECTING: "CONNECTING",
  REGISTERED: "REGISTERED",
  REGISTRATION_FAILED: "REGISTRATION_FAILED",
  INCOMING_CALL: "INCOMING_CALL",
  INCOMING_CONNECTING: "INCOMING_CONNECTING",
  OUTGOING_CALL: "OUTGOING_CALL",
  ACTIVE_CALL: "ACTIVE_CALL",
  HOLD: "HOLD",
  ENDED: "ENDED",
  FAILED: "FAILED",
};

export const BrowserPhoneAction = {
  SET_CONFIG: "SET_CONFIG",
  SET_STATE: "SET_STATE",
  SET_ERROR: "SET_ERROR",
  SET_CALL: "SET_CALL",
  SET_MUTED: "SET_MUTED",
  SET_HOLD: "SET_HOLD",
  SET_HISTORY: "SET_HISTORY",
};
